import React, { useEffect, useState } from 'react';
import { useAuth } from './AuthContext';
import { authApi } from './api';

/** Render a minimal subset of markdown (headings, bold, lists, paragraphs). */
function EulaMarkdown({ text }) {
  const blocks = String(text || '')
    .split(/\n\n+/)
    .map((b) => b.trim())
    .filter(Boolean);

  const inline = (s) => {
    const parts = [];
    const re = /\*\*([^*]+)\*\*/g;
    let last = 0;
    let m;
    let key = 0;
    while ((m = re.exec(s))) {
      if (m.index > last) parts.push(s.slice(last, m.index));
      parts.push(<strong key={key++}>{m[1]}</strong>);
      last = m.index + m[0].length;
    }
    if (last < s.length) parts.push(s.slice(last));
    return parts;
  };

  return (
    <div className="auth-eula-body">
      {blocks.map((block, i) => {
        if (block.startsWith('# ')) {
          return (
            <h2 key={i} className="auth-eula-h1">
              {inline(block.slice(2))}
            </h2>
          );
        }
        if (block.startsWith('## ')) {
          return (
            <h3 key={i} className="auth-eula-h2">
              {inline(block.slice(3))}
            </h3>
          );
        }
        if (block.split('\n').every((line) => line.startsWith('- '))) {
          return (
            <ul key={i} className="auth-eula-list">
              {block.split('\n').map((line, j) => (
                <li key={j}>{inline(line.slice(2))}</li>
              ))}
            </ul>
          );
        }
        return (
          <p key={i} className="auth-eula-p">
            {block.split('\n').map((line, j, arr) => (
              <React.Fragment key={j}>
                {inline(line)}
                {j < arr.length - 1 ? <br /> : null}
              </React.Fragment>
            ))}
          </p>
        );
      })}
    </div>
  );
}

export default function AcceptEula() {
  const { acceptEula, logout } = useAuth();
  const [doc, setDoc] = useState(null);
  const [error, setError] = useState('');
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    authApi
      .getEula()
      .then(setDoc)
      .catch((err) => setError(err.message || 'Could not load the license agreement'));
  }, []);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setError('');
    try {
      await acceptEula();
    } catch (err) {
      setError(err.message || 'Could not record acceptance');
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="auth-shell">
      <form className="auth-card auth-card-eula" onSubmit={submit}>
        <div className="auth-brand">D2D</div>
        <h1>End User License Agreement</h1>
        <p className="auth-lead">
          Please review and accept the Data2Dollars (JPL Technologies) license to continue using
          Eagle VDR / D2D Energy.
        </p>
        {error && <div className="auth-error">{error}</div>}
        {doc ? (
          <>
            <p className="auth-fine">Version {doc.version}</p>
            <EulaMarkdown text={doc.text} />
          </>
        ) : (
          !error && <p className="auth-lead">Loading agreement…</p>
        )}
        <button type="submit" className="auth-primary" disabled={busy || !doc}>
          {busy ? 'Saving…' : 'I Agree'}
        </button>
        <button type="button" className="auth-link" onClick={() => logout()}>
          Sign out
        </button>
        <p className="auth-fine">Data2Dollars · JPL Technologies</p>
      </form>
    </div>
  );
}
